import { render, staticRenderFns } from "./UpdateEarning.vue?vue&type=template&id=1519d56a&"
import script from "./UpdateEarning.vue?vue&type=script&lang=js&"
export * from "./UpdateEarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports